import * as bootstrap from 'bootstrap';

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'collapse', 'todoTitle', 'inputTitle'];

  connect () {
    this.collapsible = new bootstrap.Collapse(this.collapseTarget, {
      toggle: false,
      parent: this.collapseTarget.closest('.accordion')
    });
  }

  toggle () {
    this.collapsible.toggle();
    this.buttonTarget.ariaExpanded = this.buttonTarget.ariaExpanded !== 'true';
  }

  addInputValue () {
    this.todoTitleTarget.innerHTML = this.inputTitleTarget.value;
  }
}
